'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        color: variables.COLORS.GREYSCALE_25,
        fontSize: variables.SIZES.TEXT_SMALL,
        fontFamily: variables.VARIOUS.FONT_FAMILY,
        fontWeight: variables.WEIGHTS.MEDIUM,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        lineHeight: 1,
        "&$focused": {
            color: variables.COLORS.TEXT_PRIMARY,
        },
        "&$error": {
            color: variables.COLORS.TEXT_SECONDARY,
        },
        "&[optional=true]": {
            "&:after": {
                color: variables.COLORS.TEXT_SECONDARY,
                position: "absolute",
                content: "'(optional)'",
                fontWeight: variables.WEIGHTS.REGULAR,
                marginLeft: "4px",
            },
        },
    },
    asterisk: {
        visibility: "hidden",
        display: "inline-flex",
        "&::after": {
            visibility: "visible",
            color: variables.COLORS.TEXT_SECONDARY,
            position: "absolute",
            content: "'(required)'",
            fontWeight: variables.WEIGHTS.REGULAR,
            marginLeft: "4px",
        },
    },
};

var MuiFormLabel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiFormLabel = MuiFormLabel;
exports.light = light;
